<template>
  <index v-if="isShowApp" />
  <div class="modal-target" />
</template>

<script setup lang="ts">
  import { onErrorCaptured, useShadowRoot } from 'vue';
  import { captureException } from '@experience/core-hostapp-share-lib';
  import { initHotReloader } from '@experience/vite-plugin-wc-extract-styles';
  import { setCssFilesLinksAttribute } from '@experience/vite-plugin-wc-extract-styles';
  import { useRuntimeConfig } from 'virtual:runtime-config';

  import index from './pages/listing/ui/ListingPage.vue';

  const MF_NAME = 'experience-mf-listing';
  const SENTRY_DSN = useRuntimeConfig()[MF_NAME].VITE_RUNTIME_SENTRY_DSN ?? '';

  onErrorCaptured((err) => captureException(err, { mf: MF_NAME, dsn: SENTRY_DSN, mfRelease: __APP_VERSION__ }));

  // isShowApp - отображать страницу только после того, как будет инициализирован router (для корректных запросов)
  // TODO: также нужно добавить проверку в сами запросы, на наличия slug (доработка)
  const isShowApp = ref(false);

  const router = useRouter();

  onMounted(async () => {
    await router.isReady();

    await nextTick();
    isShowApp.value = true;

    // Mark first page load complete after a delay to allow skeleton to show
    setTimeout(() => {
      sessionStorage.setItem('skeleton-lib:page-loaded', 'true');
    }, 100);
  });

  const shadowRoot = useShadowRoot();

  setCssFilesLinksAttribute(
    shadowRoot,
    import.meta.env.MODE === 'production' ? `/mfs/${MF_NAME}/` : '/',
    'data-external-style-url',
    '%%PROD_STYLESHEET_FILE_LINK%%',
    '',
  );

  provide('shadowRoot', shadowRoot);

  initHotReloader(import.meta.hot, shadowRoot);
</script>

<style lang="scss">
  .modal-target .animate {
    z-index: 10003;
  }
</style>
